/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_RequiredInputs */

const en_issue_required = /** @type {(inputs: Issue_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`missing`)
};

/**
* | output |
* | --- |
* | "missing" |
*
* @param {Issue_RequiredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_required = /** @type {((inputs?: Issue_RequiredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_RequiredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_required(inputs)
});